import { render, staticRenderFns } from "./FaqSimple.vue?vue&type=template&id=adb9cdde&"
import script from "./FaqSimple.vue?vue&type=script&lang=js&"
export * from "./FaqSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports